import React from 'react';
import { Trash2 } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';

/**
 * Generic "are you sure?" dialog for destructive deletes.
 *
 * Props:
 *  - confirmDelete: null, or an object with a `name` shown in the body.
 *    Null means the dialog is closed — parents mount it unconditionally.
 *  - onCancel / onConfirm: parent callbacks; the modal itself performs
 *    no deletion — it is presentation only.
 *
 * Built on the Radix Dialog wrapper (components/ui/dialog.js), which
 * supplies focus trapping, Escape dismissal, focus restore and
 * role="dialog" semantics. Escape and overlay-click both route to
 * onCancel so parent state stays consistent.
 */
const ConfirmDeleteModal = ({ confirmDelete, onCancel, onConfirm }) => (
  <Dialog open={!!confirmDelete} onOpenChange={(o) => { if (!o) onCancel(); }}>
    <DialogContent className="max-w-sm p-6">
      <div className="flex items-center space-x-3 mb-4">
        <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center shrink-0">
          <Trash2 className="h-5 w-5 text-red-600" />
        </div>
        <div>
          <DialogTitle className="text-base">Delete permanently?</DialogTitle>
          <p className="text-sm text-gray-500 mt-0.5">This cannot be undone.</p>
        </div>
      </div>
      <p className="text-sm text-gray-700 bg-gray-50 rounded-lg px-3 py-2 mb-5 font-medium">{confirmDelete?.name}</p>
      <div className="flex space-x-3">
        <button onClick={onCancel} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 text-sm font-medium">Cancel</button>
        <button onClick={onConfirm} className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-medium flex items-center justify-center space-x-1">
          <Trash2 className="h-4 w-4" /><span>Delete</span>
        </button>
      </div>
    </DialogContent>
  </Dialog>
);

export default ConfirmDeleteModal;
